import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
 const navigate = useNavigate();

 return (
    <div className="min-h-screen bg-bgMain text-body p-6 md:p-12">
      <div className="max-w-4xl mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="mb-8 px-6 py-2.5 bg-white text-heading font-black rounded-xl hover:bg-bgSoft transition shadow-xl border border-accentGray/20 flex items-center gap-2 uppercase text-xs tracking-widest"
          title="Go back to previous page"
        >
          ← Back
        </button>

        <div className="bg-bgSection p-8 md:p-12 rounded-[40px] border border-accentGray/20 shadow-2xl relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl -mr-32 -mt-32"></div>
          
          <h1 className="text-4xl font-black bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent mb-10 uppercase tracking-tighter relative z-10">Terms of Service</h1>
          
          <div className="space-y-10 relative z-10">
            <section>
              <h2 className="text-xl font-black text-heading mb-4 uppercase tracking-tight flex items-center gap-3">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm">01</span>
                Acceptance of Terms
              </h2>
              <p className="text-lg leading-relaxed text-body font-medium">
                By accessing and using TheSkillGenie, you accept and agree to be bound by the terms and provision of this agreement.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-black text-heading mb-4 uppercase tracking-tight flex items-center gap-3">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm">02</span>
                Use License
              </h2>
              <p className="text-lg leading-relaxed text-body font-medium">
                Permission is granted to temporarily access the materials on TheSkillGenie's website for personal, non-commercial transitory viewing only.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-black text-heading mb-4 uppercase tracking-tight flex items-center gap-3">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm">03</span>
                User Accounts
              </h2>
              <p className="text-lg leading-relaxed text-body font-medium">
                You are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility for all activities that occur under your account.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-black text-heading mb-4 uppercase tracking-tight flex items-center gap-3">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm">04</span>
                Subscription and Payments
              </h2>
              <p className="text-lg leading-relaxed text-body font-medium">
                Subscription fees are charged in advance on a monthly or annual basis. All fees are non-refundable except as required by law.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-black text-heading mb-4 uppercase tracking-tight flex items-center gap-3">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm">05</span>
                Intellectual Property
              </h2>
              <p className="text-lg leading-relaxed text-body font-medium">
                All content, features, and functionality of TheSkillGenie are owned by TheSkillGenie and are protected by international copyright, trademark, and other intellectual property laws.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-black text-heading mb-4 uppercase tracking-tight flex items-center gap-3">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm">06</span>
                Prohibited Uses
              </h2>
              <p className="text-lg leading-relaxed text-body font-medium">
                You may not use TheSkillGenie for any unlawful purpose or to solicit others to perform unlawful acts. You may not violate any local, state, national, or international law or regulation.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-black text-heading mb-4 uppercase tracking-tight flex items-center gap-3">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm">07</span>
                Disclaimer
              </h2>
              <p className="text-lg leading-relaxed text-body font-medium">
                The materials on TheSkillGenie's website are provided on an 'as is' basis. TheSkillGenie makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-black text-heading mb-4 uppercase tracking-tight flex items-center gap-3">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm">08</span>
                Limitations
              </h2>
              <p className="text-lg leading-relaxed text-body font-medium">
                In no event shall TheSkillGenie or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on TheSkillGenie's website.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-black text-heading mb-4 uppercase tracking-tight flex items-center gap-3">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm">09</span>
                Revisions
              </h2>
              <p className="text-lg leading-relaxed text-body font-medium">
                TheSkillGenie may revise these terms of service at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-black text-heading mb-4 uppercase tracking-tight flex items-center gap-3">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm">10</span>
                Contact Information
              </h2>
              <p className="text-lg leading-relaxed text-body font-medium">
                If you have any questions about these Terms of Service, please contact us at <span className="text-primary font-bold">connect@evolvexinnovations.org</span>
              </p>
            </section>

            <div className="pt-8 border-t border-accentGray/10">
              <p className="text-sm text-muted font-bold uppercase tracking-widest">
                Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;




